import React from "react";
import PropTypes from "prop-types";
import Card from "../../components/cards/Card";
import CardGridEl from "../../components/cards/CardWrapper/CardGridEl";

const CardList = React.memo(({ cards }) => {
  return (
    <>
      {cards.filter(Boolean).map((card, y) => {
        const { Card: CardComp, id } = card;
        return (
          <CardGridEl id={id} key={id} column={0} row={y} card={card}>
            <CardComp key={id} card={card} />
          </CardGridEl>
        );
      })}
    </>
  );
});

CardList.propTypes = {
  cards: PropTypes.arrayOf(PropTypes.instanceOf(Card)),
};

CardList.defaultProps = {
  cards: [],
};

export default CardList;
